import { render, staticRenderFns } from "./GuardianTable.vue?vue&type=template&id=88228f14"
import script from "./GuardianTable.vue?vue&type=script&lang=js"
export * from "./GuardianTable.vue?vue&type=script&lang=js"
import style0 from "./GuardianTable.vue?vue&type=style&index=0&id=88228f14&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports